module.exports = __webpack_public_path__ + "static/media/ppe_kne_pad.23a29f82.png";